<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    title="免租期设置"
    width="65%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form :model="dynamicForm" ref="dynamicFormRef" label-width="120px" :disabled="isDisabled">
        <el-row :gutter="20" v-for="(item, index) of dynamicForm.dynamicList" :key="index">
          <el-col :span="9">
            <el-form-item
              :prop="`dynamicList.${index}.${key1}`"
              :label="`${text1Message}`"
              :rules="[
                { required: isRequiredKey1, message: `请选择${text1Message}`, trigger: 'blur' },
              ]"
            >
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="item[key1]"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item
              :prop="`dynamicList.${index}.${key2}`"
              :label="`${text2Message}`"
              :rules="[
                { required: isRequiredKey2, message: `请选择${text2Message}`, trigger: 'blur' },
              ]"
            >
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="item[key2]"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions2"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-if="!isDisabled">
            <el-button type="danger" @click="deleteItem(item)">删除</el-button>
          </el-col>
        </el-row>
        <el-row v-if="!isDisabled">
          <el-form-item>
            <el-button @click="addItem" type="primary">新增</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <template #footer v-if="!isDisabled">
      <el-button type="primary" @click="submitHandler" size="small">提交</el-button>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'SettleRentFreeDialog',
    props: {
      // 字段一的文本
      text1Message: {
        type: String,
        default: '免租开始时间',
      },
      text2Message: {
        type: String,
        default: '免租结束时间',
      },
      // 字段一的key
      key1: {
        type: String,
        default: 'freeRentStart',
      },
      key2: {
        type: String,
        default: 'freeRentEnd',
      },
      // 字段一必填?
      isRequiredKey1: {
        type: Boolean,
        default: true,
      },
      isRequiredKey2: {
        type: Boolean,
        default: true,
      },
      // 是否禁用
      isDisabled: {
        type: Boolean,
        default: false,
      },
      // // 初始化表单数据
      // initFormData: {
      //   type: Array,
      //   default: () => [],
      // },
      errorMessage: {
        type: String,
        default: '请填写完资料',
      },
      requireAtLeastOneRecord: {
        type: Boolean,
        default: false,
      },
      // 提交给后端的字段
      freeInfos: {
        type: String,
        default: 'freeInfos',
      },
    },
    data() {
      return {
        dynamicForm: {
          dynamicList: [{ [this.key1]: '', [this.key2]: '' }],
        },
        dialogVisible: false,
        rowItem: null,
        pickerOptions1: null,
        pickerOptions2: null,
        initFormData: [],
      };
    },
    methods: {
      addItem() {
        this.dynamicForm.dynamicList.push({ [this.key1]: '', [this.key2]: '' });
      },
      deleteItem(item) {
        if (this.requireAtLeastOneRecord && this.dynamicForm.dynamicList.length == 1) {
          this.$message.error(this.errorMessage);
          return;
        }
        const index = this.dynamicForm.dynamicList.indexOf(item);
        if (index !== -1) {
          this.dynamicForm.dynamicList.splice(index, 1);
        }
      },
      openModel(rowItem, leaseDateFrom, leaseDateUntil) {
        this.rowItem = rowItem;
        console.log('rowItem', rowItem);
        this.pickerOptions1 = {
          disabledDate(time) {
            return (
              new Date(leaseDateFrom).getTime() - 3600 * 1000 * 24 > time.getTime() ||
              time.getTime() > new Date(leaseDateUntil).getTime()
            );
          },
        };
        this.pickerOptions2 = {
          disabledDate(time) {
            return (
              new Date(leaseDateUntil).getTime() < time.getTime() ||
              time.getTime() < new Date(leaseDateFrom).getTime()
            );
          },
        };
        this.initFormData = rowItem[this.freeInfos] || [];
        console.log(this.initFormData, 'initFormData');
        this.dialogVisible = true;
      },
      // 提交
      async submitHandler() {
        try {
          const data = await this.getValidateFormData();
          console.log(data, '表单数据');
          const findData = { ...this.rowItem, [this.freeInfos]: data };
          this.$emit('submit', findData);
          this.dialogVisible = false;
          this.dynamicForm.dynamicList = [{ [this.key1]: '', [this.key2]: '' }];
        } catch (e) {
          console.log(e);
        }
      },
      // 校验数据
      getValidateFormData() {
        return new Promise((resolve, reject) => {
          if (this.requireAtLeastOneRecord && this.dynamicForm.dynamicList.length == 0) {
            this.$message.error('请填补充资料');
            return;
          }
          this.$refs.dynamicFormRef.validate((valid) => {
            if (valid) {
              resolve(this.dynamicForm.dynamicList);
            } else {
              this.$message.error(this.errorMessage);
              reject([]);
            }
          });
        });
      },
    },
    watch: {
      initFormData: {
        handler(newVal) {
          if (newVal && Array.isArray(newVal) && newVal.length) {
            this.dynamicForm.dynamicList = newVal.map((item) => {
              return {
                ...item,
                [this.key1]: item[this.key1],
                [this.key2]: item[this.key2],
              };
            });
          } else {
            this.dynamicForm.dynamicList = [{ [this.key1]: '', [this.key2]: '' }];
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
